/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetSafetyConsultantPeriodicReportResponse } from '../models/get-safety-consultant-periodic-report-response';
import { GetFormRequest } from '../models/get-form-request';
import { CreateSafetyConsultantPeriodicReportRequest } from '../models/create-safety-consultant-periodic-report-request';
import { UpdateSafetyConsultantPeriodicReportRequest } from '../models/update-safety-consultant-periodic-report-request';
@Injectable({
  providedIn: 'root',
})
class SafetyConsultantPeriodicReportService extends __BaseService {
  static readonly SafetyConsultantPeriodicReportGetAllPath = '/SafetyConsultantPeriodicReport/GetAll';
  static readonly SafetyConsultantPeriodicReportGetByIdPath = '/SafetyConsultantPeriodicReport/GetById';
  static readonly SafetyConsultantPeriodicReportCreatePath = '/SafetyConsultantPeriodicReport/Create';
  static readonly SafetyConsultantPeriodicReportUpdatePath = '/SafetyConsultantPeriodicReport/Update';
  static readonly SafetyConsultantPeriodicReportUploadFilePath = '/SafetyConsultantPeriodicReport/UploadFile';
  static readonly SafetyConsultantPeriodicReportDeletePath = '/SafetyConsultantPeriodicReport/Delete';
  static readonly SafetyConsultantPeriodicReportDeleteRangePath = '/SafetyConsultantPeriodicReport/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  SafetyConsultantPeriodicReportGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetSafetyConsultantPeriodicReportResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyConsultantPeriodicReport/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetSafetyConsultantPeriodicReportResponse>>;
      })
    );
  }  SafetyConsultantPeriodicReportGetAll(): __Observable<Array<GetSafetyConsultantPeriodicReportResponse>> {
    return this.SafetyConsultantPeriodicReportGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetSafetyConsultantPeriodicReportResponse>)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantPeriodicReportGetByIdResponse(request: GetFormRequest): __Observable<__StrictHttpResponse<GetSafetyConsultantPeriodicReportResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantPeriodicReport/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetSafetyConsultantPeriodicReportResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantPeriodicReportGetById(request: GetFormRequest): __Observable<GetSafetyConsultantPeriodicReportResponse> {
    return this.SafetyConsultantPeriodicReportGetByIdResponse(request).pipe(
      __map(_r => _r.body as GetSafetyConsultantPeriodicReportResponse)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantPeriodicReportCreateResponse(request: CreateSafetyConsultantPeriodicReportRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantPeriodicReport/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantPeriodicReportCreate(request: CreateSafetyConsultantPeriodicReportRequest): __Observable<string> {
    return this.SafetyConsultantPeriodicReportCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantPeriodicReportUpdateResponse(request: UpdateSafetyConsultantPeriodicReportRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/SafetyConsultantPeriodicReport/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantPeriodicReportUpdate(request: UpdateSafetyConsultantPeriodicReportRequest): __Observable<Blob> {
    return this.SafetyConsultantPeriodicReportUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SafetyConsultantPeriodicReportService.SafetyConsultantPeriodicReportUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyConsultantPeriodicReportUploadFileResponse(params: SafetyConsultantPeriodicReportService.SafetyConsultantPeriodicReportUploadFileParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.FormId != null) { __formData.append('FormId', params.FormId as string | Blob);}
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantPeriodicReport/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SafetyConsultantPeriodicReportService.SafetyConsultantPeriodicReportUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyConsultantPeriodicReportUploadFile(params: SafetyConsultantPeriodicReportService.SafetyConsultantPeriodicReportUploadFileParams): __Observable<Blob> {
    return this.SafetyConsultantPeriodicReportUploadFileResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  SafetyConsultantPeriodicReportDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyConsultantPeriodicReport/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  SafetyConsultantPeriodicReportDelete(id?: string): __Observable<Blob> {
    return this.SafetyConsultantPeriodicReportDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  SafetyConsultantPeriodicReportDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyConsultantPeriodicReport/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  SafetyConsultantPeriodicReportDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.SafetyConsultantPeriodicReportDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SafetyConsultantPeriodicReportService {

  /**
   * Parameters for SafetyConsultantPeriodicReportUploadFile
   */
  export interface SafetyConsultantPeriodicReportUploadFileParams {
    FormId?: string;
    File?: null | Blob;
    DirectoryPath?: null | string;
  }
}

export { SafetyConsultantPeriodicReportService }
